import React from 'react'
import { XIcon } from '@heroicons/react/outline'
import { useRecoilValue } from 'recoil'
import { quizDetail } from '../../recoil/quiz'

const QuizModal = (props) => {
  const quiz = useRecoilValue(quizDetail);

  const answerItem = (answer, index) => {
    if (index === quiz.true_answer) {
      return <div key={index} className="px-3 py-2 text-sm text-white rounded-lg bg-emerald-400">{answer}</div>;
    }
    return <div key={index} className="px-3 py-2 text-sm bg-white rounded-lg">{answer}</div>;
  }

  const loadAnswers = () => {
    return (
      <div className="flex flex-col gap-1 mb-5">
          <div className="text-sm text-slate-300">Jawaban</div>
          {
            quiz.answers.map((item, i) => answerItem(item, i))
          }
      </div>
    );
  };

  return (
    <div className="fixed flex items-center justify-center w-screen min-h-screen bg-black bg-opacity-50">
        <div className="w-1/3 p-5 bg-white rounded-lg shadow">
            <div className="flex justify-between mb-5">
              <h3 className="text-lg font-semibold">Detail Soal</h3>
              <XIcon className="w-5 h-5 cursor-pointer hover:text-blue-600" onClick={props.closeQuiz} />
            </div>
            <div className="mb-5">
                <div className="mb-1 text-sm text-slate-300">Soal</div>
                <p>{quiz.question}</p>
            </div>
            {loadAnswers()}
        </div>
    </div>
  )
}

export default QuizModal